










































































import { Component, Vue, Inject, Prop, Emit } from "vue-property-decorator";
import { Asdcom } from "@/asdcom/appservice.asdcom";
import Footer from "@/components/Footer.vue";
import TenantSwitch from "@/components/tenant-switch.vue";
import LanguageSwitch from "@/components/language-switch.vue";
import BaseComponent from "@/asdcom/BaseComponent";
import {
  ResetPasswordInput,
  ResetPasswordOutput,
  ISecurityQuestionDto,
  RetrieveRandomSecurityQInput,
  IResetPasswordInput
} from "@/asdcom/apiproxy/apiproxy.dto";

@Component({
  components: {
    Footer,
    TenantSwitch,
    LanguageSwitch
  }
})
export default class ResetPassword extends BaseComponent {
  loading: boolean = false;
  viewModel = <IResetPasswordInput>{
    securityQuestion: ""
  };
  newPassConfirm: string | null = null;

  async created() {
    try {
      const code = String(this.$route.query.c);
      // abp.log.debug({ "reset-password.vue: code": code });
      const question = await this.$appsvs.account.retrieveRandomSecurityQuestionForPasswordReset(
        new RetrieveRandomSecurityQInput({ c: code })
      );
      this.viewModel.securityQuestion = question.securityQuestion;
      this.viewModel.c = code;
    } catch (error) {
      //abp.log.error({ "reset-password.vue error": error });
      sweetAlert(this.L("Error"), this.L("RequestError"), "error");
      this.navigateHome();
    }

    // // const testUrl = 'http://localhost:8080/account/ResetPassword?userId=10&resetCode=C5E9450409&tenantId=2';
    // // this.returnUrl = this.$route.fullPath;
    // this.$appsvs.profile.getRandomSecurityQuestion()
    // .then((res: SecurityQuestionDto) => {
    //   console.log(res)
    // })
    // if (this.$route.query) {
    //   this.model.returnUrl = this.$route.fullPath;
    //   this.model.c = JSON.stringify(this.$route.query.c);
    // }
    // // window.passwordComplexitySetting = @Html.Raw(Model.PasswordComplexitySetting.ToJsonString(indented: true));
    // // https://www.google.com/url?hl=ru&amp;q=http://securetest.Heart4Victims.org/Account/ResetPassword?userId%3D13%26resetCode%3DF68D07A30E%26tenantId%3D2&amp;source=gmail&amp;ust=1528910312504000&amp;usg=AFQjCNERPw341R8WOm0og92gFL1dkM2U0w
    // // <a href="http://securetest.Heart4Victims.org/Account/ResetPassword?userId=13&amp;resetCode=F68D07A30E&amp;tenantId=2" target="_blank" data-saferedirecturl="https://www.google.com/url?hl=ru&amp;q=http://securetest.Heart4Victims.org/Account/ResetPassword?userId%3D13%26resetCode%3DF68D07A30E%26tenantId%3D2&amp;source=gmail&amp;ust=1528910312504000&amp;usg=AFQjCNERPw341R8WOm0og92gFL1dkM2U0w">http://securetest.<wbr>Heart4Victims.org/Account/<wbr>ResetPassword?userId=13&amp;<wbr>resetCode=F68D07A30E&amp;tenantId=<wbr>2</a>
  }

  async submit() {
    this.ValidateAll().then( (isValid: boolean) => {
      abp.log.debug({'reset-password.vue: submit() isValid':isValid});
      if (isValid) {
        var input = new ResetPasswordInput(this.viewModel);
        this.$appsvs.account
          .resetPassword(input)
          .then((rep: ResetPasswordOutput) => {
            if (rep && rep.canLogin) {
              sweetAlert(
                this.L("Success"),
                this.L("PasswordResetSuccess"),
                "success"
              );
            }
            this.navigateHome();
          })
          .catch(e => {
            sweetAlert(
              this.L("Error"),
              this.L("UnableToResetPassword"),
              "error"
            );
          });
        
      }
    });
  }

  public navigateHome(): void {
    this.$router.push("/");
  }
}
